import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router";
import { ApiError, auth } from "../api/client";
import { ErrorBox, Field, Wordmark, errorMessage } from "../components/ui";
import { fmt, t } from "../i18n";
import { isValidEmail } from "../lib/validators";

export function CriarConta() {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [requested, setRequested] = useState<string | null>(null);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    if (!name.trim() || !email || !password) return setError(t.auth.fillAll);
    if (!isValidEmail(email)) return setError(t.auth.invalidEmail);
    if (password.length < 10) return setError(t.auth.weakPassword);
    setPending(true);
    try {
      await auth.register({ name: name.trim(), email: email.trim(), password });
      setRequested(email.trim());
    } catch (err) {
      if (err instanceof ApiError && err.status === 429) setError(t.auth.rateLimited);
      else setError(errorMessage(err));
    } finally {
      setPending(false);
    }
  }

  if (requested) {
    return (
      <div className="auth-wrap">
        <div className="card auth-card stack">
          <Wordmark style={{ fontSize: 28, paddingBottom: 12 }} />
          <div className="stack s8">
            <span className="pill warn"><i aria-hidden="true" />{t.auth.betaBadge}</span>
            <h1 className="lead">{t.auth.requestedTitle}</h1>
            <p className="ink2">{fmt(t.auth.requestedLead, { email: requested })}</p>
          </div>
          <button type="button" className="btn ghost full" onClick={() => navigate("/entrar", { replace: true })}>{t.auth.signIn}</button>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-wrap">
      <div className="card auth-card">
        <Wordmark style={{ fontSize: 28, paddingBottom: 12 }} />
        <form onSubmit={submit} className="stack" noValidate>
          <div className="stack s8">
            <span className="pill warn" style={{ alignSelf: "flex-start" }}><i aria-hidden="true" />{t.auth.betaBadge}</span>
            <h1 className="lead">{t.auth.createTitle}</h1>
            <p className="ink2">{t.auth.createLead}</p>
          </div>
          <Field label={t.auth.name}>
            {(id, d) => (
              <div className="inp">
                <input id={id} autoComplete="name" value={name} onChange={(e) => setName(e.target.value)} aria-describedby={d} required />
              </div>
            )}
          </Field>
          <Field label={t.auth.email}>
            {(id, d) => (
              <div className="inp">
                <input id={id} type="email" autoComplete="username" inputMode="email" value={email} onChange={(e) => setEmail(e.target.value)} aria-describedby={d} required />
              </div>
            )}
          </Field>
          <Field label={t.auth.password} hint={t.auth.passwordHint}>
            {(id, d) => (
              <div className="inp">
                <input id={id} type="password" autoComplete="new-password" minLength={10} value={password} onChange={(e) => setPassword(e.target.value)} aria-describedby={d} required />
              </div>
            )}
          </Field>
          {error && <ErrorBox error={new Error(error)} />}
          <button className="btn full" type="submit" disabled={pending}>
            {pending ? t.auth.creating : t.auth.requestAccess}
          </button>
          <p className="ink2" style={{ fontSize: 13 }}>
            {t.auth.haveAccount} <Link to="/entrar">{t.auth.signIn}</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
